import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { useAppAuth } from '../auth/appAuth';
import { useNavigate } from 'react-router-dom';
import { useAxiosClient } from '../utils/useAxiosClient';

const CallbackPage: React.FC = () => {
  const { handleRedirectCallback } = useAppAuth();
  const navigate = useNavigate();
  const axiosClient = useAxiosClient();

  React.useEffect(() => {
    const handleCallback = async () => {
      // Only process if the query contains a "code"
      if (!window.location.search.includes("code")) {
        navigate('/', { replace: true });
        return;
      }
      try {
        const redirectResult = await handleRedirectCallback();
        const appStateReturnTo = (redirectResult?.appState as { returnTo?: string } | undefined)?.returnTo;
        
        // Get the redirect URL with org_id from backend
        const response = await axiosClient.get('/callback');
        const { redirect_url } = response.data;
        
        const finalDestination = appStateReturnTo || redirect_url;

        // Navigate to the provided URL
        navigate(finalDestination, { replace: true });
      } catch (error) {
        console.error('Error handling callback:', error);
        navigate('/', { replace: true });
      }
    };
    handleCallback();
  }, [handleRedirectCallback, navigate, axiosClient]);

  return (
    <Box sx={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <CircularProgress />
    </Box>
  );
};

export default CallbackPage; 